import { valueExists } from '../utils';

export const getExpiryDateObj = (expiryDates, quantity, isMarket) => {
	if (Object.keys(expiryDates || {}).length) {

		if (isMarket) {
			return { 1: expiryDates[1] };
		}

		return expiryDates;
	}

	if (isMarket) {
		return { 1: null };
	}

	const obj = {};
	for (let i = 1; i <= quantity; i++) {
		obj[i] = null;
	}

	return obj;
};

export const getAdjustedExpiryDatesByQuantityChange = (expiryDates, quantity, isMarket) => {

	if (isMarket && valueExists(expiryDates)) {
		return { 1: expiryDates[1] };
	}

	if (!quantity || !valueExists(expiryDates)) {
		return {};
	}

	const newExpiryDatesObj = {};

	for (let i = 1; i <= quantity; i++) {
		if (expiryDates[i]) {
			newExpiryDatesObj[i] = expiryDates[i];
		}
	}

	return newExpiryDatesObj;
};

export const updateExpiryDates = (expiryDates, { selection, date }, planogramItemQuantity, isMarket = false) => {

	if (isMarket) {
		return { 1: date };
	}

	if (!planogramItemQuantity) {
		return {};
	}

	const newExpiryDatesObj = {};

	for (let i = 1; i <= planogramItemQuantity; i++) {
		if (i < selection) {
			newExpiryDatesObj[i] = expiryDates[i];
		}
		else {
			newExpiryDatesObj[i] = date;
		}
	}

	return newExpiryDatesObj;
};

const parseDate = (value) => {
	if (!value) {
		return null;
	}

	const parsedDate = new Date(value);
	return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const getEarliestKnownExpiryDate = (expiryDates = {}, quantity, isMarket = false) => {
	const resolvedQuantity = Math.max(0, Math.floor(Number(quantity) || 0));
	const maximumSelection = isMarket ? 1 : resolvedQuantity;
	if (!maximumSelection) {
		return null;
	}

	return Object.entries(expiryDates || {}).reduce((earliestDate, [selection, value]) => {
		const parsedSelection = Number(selection);
		if (!Number.isInteger(parsedSelection) || parsedSelection <= 0 || parsedSelection > maximumSelection) {
			return earliestDate;
		}

		const parsedDate = parseDate(value);
		if (!parsedDate) {
			return earliestDate;
		}

		return !earliestDate || parsedDate.getTime() < earliestDate.getTime()
			? parsedDate
			: earliestDate;
	}, null);
};

const toComparableDateValue = (value) => {
	const parsedDate = parseDate(value);
	return parsedDate ? parsedDate.toISOString() : null;
};

export const sortExpiryDatesByDate = (expiryDates, quantity, isMarket = false) => {
	if (isMarket && valueExists(expiryDates)) {
		return { expiryDates: { 1: expiryDates?.[1] || null }, wasReordered: false };
	}

	if (!quantity || !valueExists(expiryDates)) {
		return { expiryDates: {}, wasReordered: false };
	}

	const resolvedQuantity = Math.max(0, Number(quantity) || 0);
	const currentExpiryValues = [];

	for (let i = 1; i <= resolvedQuantity; i += 1) {
		currentExpiryValues.push(expiryDates?.[i] || null);
	}

	const knownExpiryValuesByPosition = currentExpiryValues
		.map((value, index) => ({ value, index, parsedDate: parseDate(value) }))
		.filter(item => Boolean(item.parsedDate));
	const sortedKnownExpiryValues = [...knownExpiryValuesByPosition]
		.sort((left, right) => left.parsedDate.getTime() - right.parsedDate.getTime())
		.map(item => item.value);

	const sortedExpiryDates = {};
	for (let i = 1; i <= resolvedQuantity; i += 1) {
		sortedExpiryDates[i] = null;
	}
	knownExpiryValuesByPosition.forEach(({ index }, knownValueIndex) => {
		sortedExpiryDates[index + 1] = sortedKnownExpiryValues[knownValueIndex];
	});

	const wasReordered = currentExpiryValues.some((value, index) => {
		return toComparableDateValue(value) !== toComparableDateValue(sortedExpiryDates[index + 1]);
	});

	return {
		expiryDates: sortedExpiryDates,
		wasReordered,
	};
};
